import Main from './Main.vue'
import Acls from './components/Acls.vue'
import Acl from './components/Acl.vue'

export default [
  {
    path: 'acls',
    component: Main,
    children: [
      {path: '/', component: Acls, name: 'acls'},
      {path: 'registro', component: Acl, name: 'acl.novo'},
      {path: ':id/edit', component: Acl, name: 'acl.editar'}
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/website/acl/routes.js